namespace Core {
    export enum FieldType {
        Global,
        Titles,
        IndicativePrice,
        ReviewSnippets,
        Description,
        UrgencyMessaging,
        Url,
        Summary,
        Characteristics,
        Distances,
        Facilities,
        Destinations,
        EstabGroupIds,
        RoomNightsBooked,
        LegacyFacilities,
        RoomDetails,
        Pricing,
        RoomAvailability,
        HolidayDeals,
        Airports,
        Weather,
        Recommendations,
        TransferTimes,
        UserClicks,
        UserBookings,
        AltTitles,
        HotelDeals,
        HotelAwards
    };

    export interface FieldGroupService {
        getFieldGroup(...args: FieldType[]);
        getFieldTypes();
    }
}
